import { autocomplete } from './suggestions';

export {
    autocomplete as suggestionAutoComplete,
};
